import React, { FC, useEffect, useState } from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import { Box, Modal } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next'
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import Countdown from 'react-countdown';
import CircularProgress from '@mui/material/CircularProgress';
import { useRouter } from 'next/router';
import SpecialBtn from '../Mint/SpecialBtn';
import CountDown from "../Mint/CountDown";
import { getDragonsData } from "../../../commands/mint/getDragons";
import { postRevealData } from "../../../commands/mint/postReveal";
import { bs58 } from '@project-serum/anchor/dist/cjs/utils/bytes';
import RevealModal from './RevealModal';
import RevealMovie from './RevealMovi';
import DragonCard from './DragonCard';
import { getDragonData } from '../../../commands/mint/getDragon';
import { TwitterQuestModal } from "../Quests/TwitterQuestModal";
import { getTweetUrl } from "../../../commands/nesting/getTweetUrl";

//
function Gallery(props: any) {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();
    const { wallets, wallet: selected, publicKey, signMessage } = useWallet();
    const [showRevealModal, setShowRevealModal] = useState<boolean>(false);
    const [postRevealInProg, setPostRevealInProg] = useState<boolean>(false);
    const [revealNft, setRevealNft] = useState<any>(null);
    const [playRevealMovie, setPlayRevealMovie] = useState<any>(false);
    const [checkingImg, setCheckingImg] = useState<boolean>(false);
    const [openTwitterQuest, setOpenTwitterQuest] = React.useState(false);
    const router = useRouter();

    // For /mygallery
    useEffect(() => {

        if (props.mode === 'my_gallery' && props.walletAddress) {
            props.reloadDragons(props.walletAddress, true, false);
        }

    }, [props.walletAddress]);

    // For /gallery/[userAddress] - UPDATE: We now get dragons from getInitialProps so we dont need this!!
    /*useEffect(() => {

        if (props.mode === 'gallery' && router) {
            props.reloadDragons(router.query.userAddress, true, false);
        }

    }, [router]);*/

    //
    async function doReveal(data: any) {
        // Dont allow if some reveal already in progress!
        if (postRevealInProg) {
            return;
        }

        if (signMessage) {
            const encodedMessage = new TextEncoder().encode("Reveal Your Eternal Dragon");

            signMessage(encodedMessage).then(async (signature) => {
                setRevealNft({
                    mint: data.mint
                });

                setPostRevealInProg(true);
                let res = await postRevealData(props.walletAddress, bs58.encode(signature), data.mint);
                setPostRevealInProg(false);

                if (res.status >= 0) {
                    // Play movie           
                    setPlayRevealMovie(true);
                }
                else {
                    setRevealNft(null);
                }
            }).catch(e => {
                console.log(e);
            });
        }
    }

    //
    function sleep(ms: number): Promise<void> {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    //
    async function checkDragonExist() {
        let waitMs = 1000;

        for (let i = 0; i < 100; i++) {

            if (i > 0) {
                await sleep(waitMs);
                waitMs *= 2;
            }

            try {
                let dragonRes = await getDragonData(revealNft.mint);

                // Error - try again
                if (dragonRes.status < 0 || !dragonRes.dragon) {
                    continue;
                }

                let dragon = dragonRes.dragon;

                if (dragon.name.startsWith('Eternal Dragon Egg')) {
                    console.log("Still an egg. Lets continue checking.")
                    continue;
                }

                // If exist show modal!
                console.log("Dragon exist!");
                return dragon; // Returns dragon json!
            }
            catch (e) {
                // Not exist - repeat check after 3s!
                console.log("Retry: " + i);
            }
        }

        return null;
    }

    //
    async function revealDone() {
        setShowRevealModal(true);
        setCheckingImg(false);

        // Reload reveal list
        await props.reloadDragons(props.walletAddress, false, true);
    }

    //
    async function onRevealMovieEnded() {
        setPlayRevealMovie(false);

        setCheckingImg(true);
        let dragon = await checkDragonExist();

        if (dragon) {
            let dnaAttr = dragon.attributes.find((att: any) => att.trait_type === "DNA");
            let dnaArray: string[] = [];

            if (dnaAttr) {
                for (let i = 0; i < dnaAttr.value.length; i++) {
                    dnaArray.push(dnaAttr.value[i]);
                }
            }

            setRevealNft({
                mint: revealNft.mint,
                name: dragon.name,
                dna: dnaArray,
                image: dragon.image, // taking image from json!
                score: dragon.score
            });

            setCheckingImg(false);
            revealDone();
        }
        else {
            console.log("Can't check if dragon is generated!");
        }
    }

    //
    async function skipRevealMovie() {
        await onRevealMovieEnded();
    }

    //
    function revealModalClose() {
        setShowRevealModal(false);
    }

    //
    function nestBtnHandler() {
        let text = `I am nesting my @eternaldragons_ to earn %23Eternium! Please retweet to help me boost my rewards! %23EternalDragonsNesting https://eternaldragons.com/gallery/${props.walletAddress}`;
        window.open(`https://twitter.com/intent/tweet?text=${text}`, "_blank");
    }

    //
    function verifyTwitterHandler() {
        setOpenTwitterQuest(true);
    }

    //
    async function interactWithTwitterHandler() {
        let res = await getTweetUrl();

        if (res.status >= 0) {
            window.open(res.data.url, "_blank");
        }
    }

    //
    function noDragonsUi() {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "80px" }}>
                <img src="/mint/Ornament_Light.png" style={{ maxWidth: "300px", width: "100%" }} />

                <Box sx={{
                    textAlign: "center",
                    marginTop: "20px",
                    color: "#c5c5c3",
                    textShadow: "0px 0px 3px black",
                    fontSize: "20px"
                }}>
                    You have no Dragons. Join the Dragoneers.
                </Box>

                <Box sx={{
                    textAlign: "center",
                    margin: "5px 0px 5px 0px",
                    color: "#c5c5c3",
                    textShadow: "0px 0px 3px black",
                    fontSize: "20px"
                }}>
                    Find our collection on
                </Box>

                <img src="Magic_Eden_button.png"
                    style={{ maxWidth: "300px", width: "100%", margin: "0 0 70px 0", cursor: "pointer" }}
                    alt="eternal dragons magic Eden button"
                    onClick={() => window.open('https://magiceden.io/marketplace/eternal_dragons_genesis', '_blank')} />
            </Box>
        )
    }

    //
    function haveDragons() {
        return (
            <Box className="gallery_ui" sx={{
                display: "flex", displayDirection: "row", flexWrap: "wrap", justifyContent: "center",
                overflowY: "auto", alignItems: "start",
                position: "relative",
                //top: "12.85%", 
                height: "67.5%"
            }}>
                {
                    props.dragons.map((dragon: any) => {
                        return (<DragonCard
                            mode={props.mode}
                            key={dragon.mint}
                            dragon={dragon}
                            revealNft={revealNft}
                            postRevealInProg={postRevealInProg}
                            doReveal={doReveal}
                            placeholder={dragon.placeholder === true} />);
                    })
                }
            </Box>
        )
    }

    //
    function headerUi() {
        return (
            <Box sx={{ height: "12.85%", width: "100%", background: "", display: "flex", alignItems: "center", }}>

            </Box>
        )
    }

    //
    function verifyTweeter() {
        return (
            <>
                <Box sx={{ color: "#ffdfc1", marginBottom: "3px", lineHeight: 1.25, textAlign: "center", fontSize: "15px", fontWeight: 700, maxWidth: "600px" }}>
                    Take the first step towards Dragon Nesting, select &apos;Verify Twitter&apos;.
                </Box>

                <Box>
                    <SpecialBtn label="Verify Twitter"
                        //sx={{ marginLeft: "10px", marginTop: "10px" }}
                        width="150px"
                        height="34px"
                        labelSize="15px"
                        inProg={false}
                        variant="blue"
                        textColor="#212020"
                        onClick={verifyTwitterHandler}
                        disabled={false}
                    />
                </Box>
            </>
        )
    }

    //
    function gotoTweet() {
        return (
            <>
                <Box sx={{ color: "#ffdfc1", lineHeight: 1.25, textAlign: "center", fontSize: "15px", fontWeight: 700, maxWidth: "600px" }}>
                    Select &apos;Go to tweet&apos; and retweet or comment to start nesting.
                </Box>

                <Box sx={{ color: "#ffdfc1", marginBottom: "3px", lineHeight: 1.25, textAlign: "center", fontSize: "15px", fontWeight: 700, maxWidth: "600px" }}>
                    See details in the latest <a className="medium-link" target="_blank" rel="noreferrer" href="https://eternaldragons.medium.com/dragon-nesting-updates-a-new-challenge-61faf1e8df4b">Medium article</a>.
                </Box>

                <Box>
                    <SpecialBtn label="Go to tweet"
                        //sx={{ marginLeft: "10px", marginTop: "10px" }}
                        width="150px"
                        height="34px"
                        labelSize="15px"
                        inProg={false}
                        variant="blue"
                        textColor="#212020"
                        onClick={interactWithTwitterHandler}
                        disabled={false}
                    />
                </Box>
            </>
        )
    }

    //
    function footerUiFactory(twitterAnchor: string | undefined) {
        if (twitterAnchor) {
            return gotoTweet();
        }
        else {
            return verifyTweeter();
        }
    }

    //
    function footerUi() {
        return (
            <Box sx={{ height: "16%", width: "100%", background: "", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                {props.mode === 'my_gallery' && props.user && footerUiFactory(props.user.twitterAnchor)}
            </Box>
        )
    }

    //
    function galleryUi() {
        return (
            <Box sx={{
                display: "flex", justifyContent: "center", alignItems: "start",
                height: "80vh", flexDirection: "row", maxWidth: "70vw", position: "relative",
                //maxHeight: "2000px",
                minHeight: "700px"
            }}>

                <Box sx={{
                    height: "100%", position: "relative", width: "2vw", minWidth: "50px",
                    backgroundImage: "url('/mint/Container_Inventory_Left_02.png')",
                    //backgroundRepeat: "no-repeat",
                    backgroundSize: "100% 100%",
                    flexShrink: 0
                }}>
                </Box>

                <Box sx={{
                    height: "100%", position: "relative",
                    backgroundImage: "url('/mint/Container_Inventory_Middle_02.png')",
                    //backgroundRepeat: "no-repeat",
                    backgroundSize: "100% 100%",
                    //display: "flex", justifyContent: "center", alignItems: "start", flexWrap: "wrap",
                    //background: "green",
                    //padding: "58px 0px 100px 0px"
                }}>
                    {headerUi()}
                    {haveDragons()}
                    {footerUi()}
                </Box>

                <Box sx={{
                    height: "100%", position: "relative", width: "2vw", minWidth: "50px",
                    backgroundImage: "url('/mint/Container_Inventory_Right_02.png')",
                    //backgroundRepeat: "no-repeat",
                    backgroundSize: "100% 100%",
                    flexShrink: 0
                }}>
                </Box>
            </Box>
        )
    }

    // 
    function loadingUi(bg: boolean) {
        return (
            <Box sx={{ zIndex: 9999, position: "fixed", top: 0, right: 0, bottom: 0, left: 0, background: bg ? "#101010dd" : "", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <CircularProgress />
            </Box>
        )
    }

    //
    return (
        <Box className={props.className}>
            {!props.reloadDragonsInProg &&
                <>
                    {playRevealMovie && <RevealMovie onRevealMovieEnded={onRevealMovieEnded} skipRevealMovie={skipRevealMovie} />}

                    {props.dragons.length > 0 && galleryUi()}
                    {props.dragons.length === 0 && noDragonsUi()}
                </>}

            {props.reloadDragonsInProg && loadingUi(false)}
            {checkingImg && loadingUi(true)}

            {/* reveal show modal */}
            {<RevealModal open={showRevealModal} onClose={revealModalClose} nftData={revealNft} />}

            {/* Twitter quest modal */}
            <TwitterQuestModal
                open={openTwitterQuest}
                handleClose={() => setOpenTwitterQuest(false)}
                afterSuccess={(res: any, twitterUserName: string) => { props.updateQuests(res, true); props.setUserTwitter(twitterUserName) }}
            />
        </Box >
    );
}

// Default style!
const GalleryStyled = styled(Gallery)({
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    flexDirection: "column",
    marginTop: "110px",
    //padding: "20px",
    minWidth: "300px",
    minHeight: "380px",
    ".reveal-video-cont": {
        maxWidth: "900px!important",
        width: "auto!important",
        height: "auto!important",
        padding: "20px",
        iframe: {
            width: "100vw!important",
            height: "100vh!important",
            maxWidth: "700px",
            padding: "20px"
        }
    },
    ".whitelist-info-box": {
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
        flexDirection: "column",
        background: "#8f8f8f44",
        padding: "10px",
        marginTop: "70px",
        borderRadius: "15px"
    },
    ".whitelist-inner-box": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
        marginTop: "10px",
        flexWrap: "wrap",
        maxWidth: "600px"

    },
    ".whitelist-countdown-cont": {
        color: "white",
        fontWeight: 700,
        fontSize: "35px",
        marginTop: "15px"
    },
    ".wl-connect-wallet-btn": {
        fontWeight: 700,
        color: "white!important",
        width: "200px",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        display: "block",
        background: "#27558bdd"
    },
    ['@media (max-width:800px)']: {
        ".whitelist-box": {
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            flexDirection: "column",
            marginTop: "100px",
            padding: "20px",
            background: "#666363bb",
            borderRadius: "15px",
            boxShadow: "0px 0px 14px 3px #7c7c7c",
            minWidth: "300px",
            minHeight: "380px"
        },
    },
    ".gallery_ui": {
        "&::-webkit-scrollbar": {
            width: "10px"
        },
        "::-webkit-scrollbar-track": {
            background: "#896b53"
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#b3957d"
        },
        "&::-webkit-scrollbar-thumb:hover": {
            background: "#b3957d"
        }
    },
    ".medium-link": {
        color: "#fbb56f",
        textDecoration: "underline",
        "&:hover": {
            color: "#f9c693"
        }
    }
});

// Export
export default GalleryStyled;